"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MEDIUM = 'medium';
var TINY = 'tiny';

var Component = function Component(_ref) {
  var children = _ref.children,
      isCompact = _ref.isCompact,
      size = _ref.size,
      weight = _ref.weight,
      className = _ref.className;
  return _react["default"].createElement("p", {
    className: (0, _classnames["default"])(weight, className, {
      tiny: size === TINY,
      'is-compact': isCompact
    })
  }, children);
};

exports.Component = Component;
Component.displayName = 'Paragraph';
Component.defaultProps = {
  className: null,
  isCompact: false,
  size: MEDIUM,
  weight: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  className: _propTypes["default"].string,
  isCompact: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf([MEDIUM, TINY]),
  weight: _propTypes["default"].oneOf(['heavy', 'light'])
} : {};